import { useState, useContext } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { UserContext } from './context.js';
import {EmailField, PasswordField, UsernameField, Submit} from './Fields.js';
import Typography from '@mui/material/Typography';
import { Link, useNavigate } from "react-router-dom";
import nwsFetch from './customFetch.js';

export default function SignIn(){
	const navigate = useNavigate();
	const setUser = useContext(UserContext)[1];
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [password2, setPassword2] = useState("");
	const [email, setEmail] = useState("");
	const [error, setError] = useState({});
	async function onSubmit(){
		const data = {
			username: username,
			password: password,
			password2: password2,
			email: email,
		};
		let response = await nwsFetch("/accounts/api/sign_on/", {
			method: "POST",
			body: JSON.stringify(data),
		});
		if(response.ok){
			setUser(await response.json());
			return navigate("/login");
		}else{
			setError(await response.json());
		}
	}
	return (
		<Container maxWidth="sm">
			<Box component="form">
				<Typography variant="h3" component="h3">
				  Sign Up	
				</Typography>
				<UsernameField setField={setUsername} error={error}/>
				<PasswordField setField={setPassword} error={error}/>
				<PasswordField setField={setPassword2} error={error} id="password2" name="Confirm Password"/>
				<EmailField setField={setEmail} error={error}/>	
				<Submit onSubmit={onSubmit} error={error} name="Sign Up"/>
				<Typography sx={{textAlign: "center"}} variant="h6" component="h6">
					Already have an account? <Link to="/login" >Sign in</Link>
				</Typography>
			</Box>
		</Container>
	)
}
